export const events = [
  'click',
  'mousemove',
  'mousedown',
  'scroll',
  'keypress',
  'keyup',
  'load',
];
